module.exports = __webpack_public_path__ + "double-valhalla-ru-desktop.jpg";